import { useLocation, useNavigate } from 'react-router-dom';
import { getEscalationInfo } from '../../services/EscalationService';
import { saveUrlEscalation } from '../../pages/Escalation/OtpNewFlow/escalationStorage';

const useGlobalEscalation = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const operationV: { url: string; obd: boolean; otp: boolean }[] = [
        { url: '/update-personal-data', obd: true, otp: true },
        { url: '/select-bank-account', obd: true, otp: true },
        { url: '/update-bank-account', obd: true, otp: true },
        { url: '/profile/update-password', obd: true, otp: true },
        { url: '/configure-line/sim/duplicate', obd: true, otp: false },
        { url: '/configure-line/sim/duplicate/request', obd: true, otp: false },
        { url: '/configure-line/sim/feedbackSeeQRESIM', obd: true, otp: false },
        { url: '/configure-line/sim/installWithQr', obd: true, otp: false },
    ];

    const simFlows = ['duplicate', 'qr'];

    const checkEscalation = (url: string, flow?: string, params?: any) => {
        getEscalationInfo().then((response) => {
            const { data } = response;
            const { escalationType, contacts } = data;

            const { mobileVerified, emailVerified } = params || {};
            const currentOperation = operationV.find((item) => item.url === url);
            const hasOTP = currentOperation?.otp;
            const hasOBD = currentOperation?.obd;
            const newWindow = sessionStorage.getItem('newWindow')!;

            if (escalationType === 'OBD') {
                if (hasOBD) {
                    navigate(`${url}?flow=${flow}`, {
                        state: { ...location.state, escalation: escalationType },
                    });
                } else if (hasOTP) {
                    sessionStorage.setItem('params', window.location.search);
                    saveUrlEscalation(url + location.search);
                    navigate(`/escalation/contacts?contacts=${contacts}&flow=${flow}`, {
                        replace: true,
                    });
                }
            } else if (escalationType === 'OTP') {
                if (hasOBD && !hasOTP) {
                    if (newWindow) {
                        const win = window.open('', newWindow)!;
                        win.location.href = `${window.location.origin}/obd/daon?functionality=${
                            flow && simFlows.includes(flow) ? flow : 'verification'
                        }`;
                    } else {
                        window.open(
                            `${window.location.origin}/obd/daon?functionality=${
                                flow && simFlows.includes(flow) ? flow : 'verification'
                            }`,
                            '_blank',
                        );
                    }
                } else if (hasOTP) {
                    navigate(`${url}?flow=${flow}`, {
                        state: { ...location.state, escalation: escalationType },
                    });
                }
            } else if (escalationType === 'NONE') {
                if (hasOBD && !hasOTP) {
                    if (newWindow) {
                        const win = window.open('', newWindow)!;
                        win.location.href = `${window.location.origin}/obd/daon?functionality=${
                            flow && simFlows.includes(flow) ? flow : 'verification'
                        }`;
                    } else {
                        window.open(
                            `${window.location.origin}/obd/daon?functionality=${
                                flow && simFlows.includes(flow) ? flow : 'verification'
                            }`,
                            '_blank',
                        );
                    }
                } else if (contacts.length <= 0) {
                    if (mobileVerified || emailVerified) {
                        const win = window.open('', newWindow)!;
                        win.close();
                    } else {
                        if (newWindow) {
                            const win = window.open('', newWindow)!;
                            win.location.href = `${window.location.origin}/obd/daon?functionality=${
                                flow && simFlows.includes(flow) ? flow : 'verification'
                            }`;
                        } else {
                            window.open(
                                `${window.location.origin}/obd/daon?functionality=${
                                    flow && simFlows.includes(flow) ? flow : 'verification'
                                }`,
                                '_blank',
                            );
                        }
                    }
                } else if (hasOBD || hasOTP) {
                    saveUrlEscalation(url + location.search);
                    sessionStorage.setItem('params', window.location.search);
                    navigate(`/escalation/contacts?contacts=${contacts}&flow=${flow}`, {
                        replace: true,
                    });
                }
            }
        });
    };

    return { checkEscalation };
};

export default useGlobalEscalation;
